export const radianToDegree = (radian: number): number => {
  if (!radian) return 0

  return (radian * 180) / Math.PI
}
